module.exports = __webpack_public_path__ + "static/media/save_filled.87cf62fc.svg";